import { z } from 'zod';

export const CartLoginToken = z.object({
    store: z.string(),
    token: z.string(),
});

export type CartLoginToken = z.infer<typeof CartLoginToken>;
